import { useRef, useState } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { GoogleMap, InfoWindow, InfoWindowF, Marker, MarkerF, OverlayView, OverlayViewF } from "@react-google-maps/api";

import Popup from "../../../components/modal/Popup";

import Location from "../../../assets/icons/location.svg";
import Current from "../../../assets/icons/current.svg";
import { useDispatch, useSelector } from "react-redux";
import { setCord, setHomeAddress } from "../../../features/profile/reducer";
import { resetHome } from "../../../features/home/reducer";
import { types } from "util";
import { IRootState } from "../../..";

type PropType = {
  onClose: () => void;
};

const SetLocationModal = ({ onClose }: PropType) => {
  const dispatch = useDispatch();
  // MAP
  const savedAddress = useSelector((state: IRootState) => state.profile.value);
  const savedLocation = useSelector((state: IRootState) => state.profile.value);
  const [address, setAddress] = useState(savedAddress.home_address || "");
  const [cordinate, setCordinate] = useState<any>(savedLocation.cord.lat && savedLocation.cord.lng ? savedLocation.cord : {
    lat: 6.515759,
    lng: 3.3898447,
  });
  const [tempLocation, setTempLocation] =  useState(false);
  const [showTooltip, setShowTooltip] = useState(false)


  const handleGetLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setCordinate({ lat: latitude, lng: longitude });
          dispatch(
            setCord({
              lat: latitude,
              lng: longitude,
            })
          );

          try {
            const results = await geocodeByAddress(`${latitude}, ${longitude}`);
            if (results.length > 0) {
              setAddress(results[0].formatted_address);
              dispatch(setHomeAddress(results[0].formatted_address));
            } else {
              console.error("Address not found for the given coordinates.");
            }
          } catch (error) {
            console.error("Error fetching address:", error);
          }
        },
        (error) => {
          console.error("Error getting current location:", error.message);
        }
      );
      // onClose();
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const hadleSubmit = async (value: string) => {
    const result = await geocodeByAddress(value);
    const ll = await getLatLng(result[0]);
    setTempLocation(true)
    setShowTooltip(true)
    setAddress(value);
    setCordinate(ll);
    // dispatch(setHomeAddress(value));
    // dispatch(
    //   setCord({
    //     lat: ll.lat,
    //     lng: ll.lng,
    //   })
    // );
    // onClose();
  };

  const confirmLocationHandler = () => {
        dispatch(resetHome())
    dispatch(setHomeAddress(address))
    dispatch(
      setCord(cordinate)
    );
    onClose();
  }

  

  return (
    <Popup onClose={onClose} title="Set Location" showClose={tempLocation}>
      <div className="p-4 flex flex-col w-full gap-5">
        <div className="flex flex-col md:flex-row gap-4 items-center">
          <div className=" relative my-8 flex items-start gap-2 w-full md:w-3/3">
            <div className="absolute z-[100090] -top-5 w-full ">
              <PlacesAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={hadleSubmit}
                // searchOptions={{
                //   types: ['geocode']
                // }}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div className="w-full">
                    <div className="flex bg-grey gap-3 px-4 h-11 rounded-md items-center">
                      <img src={Location} alt="" className="h-5 w-5" />
                      <input
                        {...getInputProps({
                          placeholder: "Search Location",
                          className: " w-full bg-grey outline-none ",
                          disabled: tempLocation
                        })}
                      />
                    </div>
                    <div className="autocomplete-dropdown-container">
                      {loading && <div>Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? "suggestion-item--active"
                          : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? {
                              padding: "10px",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }
                          : {
                              padding: "10px",
                              backgroundColor: "#F5F5F5",
                              cursor: "pointer",
                            };
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                            key={suggestion.placeId}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
            </div>
          </div>
          {!tempLocation && <button
            className="h-11 bg-primary text-white flex px-4 outline-none rounded-md gap-2 items-center justify-center text-sm w-full md:w-1/3"
            onClick={handleGetLocation}
          >
            <img src={Current} alt="" />
            <div className="whitespace-nowrap">Use current location</div>
          </button>}
        </div>
       
        <GoogleMap
          zoom={15}
          center={{
            lat: cordinate.lat || 0,
            lng: cordinate.lng || 0,
          }}
          
          mapContainerClassName=" w-full h-[400px] rounded-md"
          options={{
            zoomControl: true,
            scaleControl: false,
            clickableIcons: true,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
          }}
        >
        <div className="relative">
        {cordinate && <MarkerF position={cordinate} draggable={true} 
          onDrag={async (e: any) => {
            setShowTooltip(false)
          }}  
          onDragEnd={async (e: any) =>  {
            setCordinate({ lat: e.latLng.lat(), lng: e.latLng.lng()})
            setTempLocation(true)
            setShowTooltip(true)
            const results = await geocodeByAddress(`${e.latLng.lat()}, ${e.latLng.lng()}`);
            if (results.length > 0) {
              setAddress(results[0].formatted_address);
            }
          }}>
             {/* { tempLocation && <InfoWindowF
                onLoad={() => {
                  setTempLocation(false);
                  setTempLocation(true)
                }}
                position={cordinate}
                >
                  <h3 className="text-center font-medium">You are here? <br /> Adjust your location</h3>
              </InfoWindowF> */}
          <OverlayViewF
          position={cordinate}
          
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          // getPixelPositionOffset={(width, height) => ({
          //   x: -(width / 2),
          //   y: -height / 2,
          // })}                       
        >
          {showTooltip &&
          <div id="tooltip-default" role="tooltip" className={`sticky bottom-24 -ml-[54%] -mt-[74%] z-20 text-center block px-3 py-2 text-sm font-normal text-black transition-opacity duration-300 bg-white w-fit rounded-lg shadow-sm tooltip ${!tempLocation && 'hidden' }`}>
              You are here? <br /> Adjust the location
          <div className="tooltip-arrow" data-popper-arrow></div>
          </div>
} 
        </OverlayViewF>
            </MarkerF>}
            </div> 
        </GoogleMap>
        {tempLocation &&
        <button
              className="h-11 bg-primary text-white flex px-4 outline-none rounded-md gap-2 items-center justify-center text-sm w-full md:w-1/3 absolute bottom-5 left-1/2 transform -translate-x-1/2"
              onClick={confirmLocationHandler}
            >
              {/* <img src={Current} alt="" /> */}
              <div className="whitespace-nowrap">Confirm location</div>
          </button>

}
</div>
       
    </Popup>
  );
};

export default SetLocationModal;
